<template>
  <SettingsPagePanel>
    <SettingsPagePanelHeader :class="$style.header">
      <template v-slot:title>企業情報</template>
    </SettingsPagePanelHeader>
    <SettingsTable>
      <SettingsTableRow name="会社名">
        <p :class="$style.text">{{ corporation.name }}</p>
        <template #rowAfter>
          <p :class="$style.notice">※会社名はユーザーには表示されません</p>
        </template>
      </SettingsTableRow>
    </SettingsTable>
  </SettingsPagePanel>
</template>

<script setup lang="ts">
import SettingsPagePanel from '../SettingsPagePanel.vue'
import SettingsPagePanelHeader from '../SettingsPagePanelHeader.vue'
import SettingsTable from '@/pages/SettingsPage/SettingsTable/SettingsTable.vue'
import SettingsTableRow from '@/pages/SettingsPage/SettingsTable/SettingsTableRow.vue'
import type { Corporation } from '@/types/app'

defineProps<{
  corporation: Corporation
}>()
</script>

<style lang="scss" module>
.title {
  &__poptip {
    display: inline-block;

    &:nth-child(n + 2) {
      margin-left: 8px;
    }
  }
}

.text {
  color: $color-text-and-object-high-emphasis;
  font-size: 16px;
  line-height: 28px;

  &--empty {
    color: $color-text-and-object-low-emphasis;
    font-size: 16px;
    line-height: 28px;
  }
}

.notice {
  font-size: 12px;
}
</style>
